import { currentLanguage, messagesForLanguage } from './index';
import { LANGUAGES, translateDisplay, type StoreLanguage } from './core';
import catalogNames from './catalogNames.json';

export function normalizeSearch(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').toLowerCase().trim();
}
const aliases: Record<string, string[]> = catalogNames;
export function matchesLocalizedSearch(source: string | string[], query: string, language: StoreLanguage = currentLanguage()): boolean {
  const needle = normalizeSearch(query);
  if (!needle) return true;
  return (Array.isArray(source) ? source : [source]).some(text => {
    if (!text) return false;
    const versions = [text, ...(aliases[text] || []), ...LANGUAGES.map(code => translateDisplay(text, messagesForLanguage(code), code))];
    if (language !== 'es') versions.push(translateDisplay(text, messagesForLanguage(language), language));
    return versions.some(version => normalizeSearch(version).includes(needle));
  });
}
export function sourceSearchTerms(query: string, language: StoreLanguage = currentLanguage()): string[] {
  const needle = normalizeSearch(query);
  const sources = Object.entries(aliases).filter(([source, translations]) =>
    [source, ...translations, translateDisplay(source, messagesForLanguage(language), language)].some(value => normalizeSearch(value).includes(needle))).map(([source]) => source);
  return [...new Set([query.trim(), ...sources])].filter(Boolean).slice(0, 48);
}
export function catalogSearchFilter(query: string, language: StoreLanguage = currentLanguage()): string {
  const literal = (text: string) => '"%' + text.replace(/[\\"%_]/g, value => '\\' + value) + '%"';
  return sourceSearchTerms(query, language).flatMap(term => ['name', 'description'].map(column => `${column}.ilike.${literal(term)}`)).join(',');
}
